module.exports = __webpack_public_path__ + "static/media/post4.5c91a4f9.jpg";